import 'whatwg-fetch';
import getCSRFToken from 'utilities/security/token-fetcher';
import {notifyException} from '../analytics/bugsnag';

export function handleFetchErrors(response = {}) {
  if (!response.ok) {
    const error = new Error(`Error ${response.status}`);
    error.response = response;
    error.status = response.status;
    throw error;
  }

  return response;
}

/**
 * All fetch requests should be chained with this middleware used to handle fetch errors and
 * report issues to Bugsnag. The `handleFetchErrors` function should be phased out and
 * eventually removed when it's not used anymore.
 *
 * @param {string} [errorName='FetchRequest::Error'] - This is how the error is presented within
 *                                                     Bugsnag. So providing some context around
 *                                                     what this requests purpose was will make
 *                                                     the error more obvious/traceable.
 * @param {object} meta - An object whose attributes will made available within the `META` tab
 *                        within a Bugsnag error instance.
 * @returns {function}
 */
export function notifyFetchErrors(
  errorName = 'FetchRequest::Error',
  meta = {}
) {
  return (response = {}) => {
    if (!response.ok) {
      const error = new Error(`Error ${response.status}`);
      notifyException({errorName, error, meta, response});
      error.response = response;
      error.status = response.status;
      throw error;
    }

    return response;
  };
}

export function fetchJSON(url, options = {}) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-Token': getCSRFToken(),
    ...options.headers,
  };

  const defaultOptions = {
    credentials: 'same-origin',
    method: 'GET',
    ...options,
    headers,
  };

  return window.fetch(url, {...defaultOptions});
}

export function postJSON(url, {body: data, options = {}} = {}) {
  return fetchJSON(url, {
    method: 'POST',
    body: JSON.stringify(data),
    ...options,
  });
}
